<template>
    <div class="input-container" v-if="type === 'text'">
        <label v-if="show_label" :for="field.title">{{ field.title }}:</label>
        <input type="text" :id="field.label"  v-model="inputValue" @input="verifyInput" :placeholder=" (field && field.placeholder) ? field.placeholder : '' " :disabled="disableInput"
        :maxlength="field.max_length"/>
    </div>
    <div class="input-container" v-else-if="type === 'number'">
        <label v-if="show_label" :for="field.title">{{ field.title }}:</label>
        <input type="number" :id="field.label"  v-model="inputValue" :placeholder=" (field && field.placeholder) ? field.placeholder : ''" :disabled="disableInput"/>
    </div>
    <div class="input-container" v-else-if="type === 'phone'">
        <label v-if="show_label" :for="field.title">{{ field.title }}:</label>
        <div class="phone-input">
            <VuePhoneNumberInput
              v-model="phone"
              :no-example="true"
              size="lg"
              :translations="translations"
              @update="setPhoneValue"
              :color="'#7c7c7c'"
              :border-radius="10"
              default-country-code="MX"
              :preferred-countries="['MX', 'US']"
              :disabled="disableInput"
              :no-country-selector="noCountrySelector"
            />
        </div>
    </div>
    <div class="checkbox-input" v-else-if="type === 'checkbox'">
        <input type="checkbox" :id="field.title"  v-model="inputValue" :disabled="disableInput" />
        <label :for="field.title" v-html="field.help"></label>
    </div>
    <div class="input-container select-input" v-else-if="type === 'select'">
        <label v-if="show_label" :for="field.title">{{ field.title }}:</label>
        <select :id="field.label" v-model="inputValue" :disabled="disableInput">
            <option v-for="option in selectOptions" :key="option" :value="option">{{ option }}</option>
        </select>
    </div>
</template>
<script>
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'
export default {
    props: {
        field: { type: Object, required: true },
        custom_select_options: { type: Array, required: false },
        query_params_default: { type: Boolean, required: false },
        show_label: { type: Boolean, required: false, default: true },
        disableInput: { type: Boolean, required: false, default: false },
        noCountrySelector: { type: Boolean, required: false, default: false },
        value: { type: [String, Number, Boolean, Object], required: false }
    },
    components: {
        VuePhoneNumberInput
    },
    data() {
        return {
            inputValue: '',
            phone: '',
            translations: {
                countrySelectorLabel: 'País',
                phoneNumberLabel: 'Escribe tu número de teléfono',
            },
        }
    },
    methods: {
        updateValue() {
            this.$emit('input', this.inputValue);
        },
        setPhoneValue(e) {
            this.$emit('input', e);
        },
        getParams(param) {
            let uri = window.location.search.substring(1);
            let params = new URLSearchParams(uri);
            return params.get(param);
        },
        verifyInput() {
            if (!this.field.extra_parameters?.input_regex) return

            const regex = new RegExp(this.field.extra_parameters.input_regex, 'g')
            this.inputValue = (this.inputValue || '').toString().replace(regex, '').trim()
        }
    },
    mounted() {
        if (this.query_params_default) {
            let param = this.getParams(this.field.slug)
            if (param) {
                this.inputValue = param
                this.updateValue()
            }
        }
    },
    watch: {
        inputValue() {
            this.updateValue()
        }
    },
    computed: {
        type() {
            switch (this.field.data_type_enum) {
                case 10:
                    return 'text';
                case 15:
                    return 'phone'
                case 20:
                    return 'number'
                case 21:
                    return 'checkbox'
                case 40:
                    return 'select'
                default:
                    return 'text';
            }
        },
        selectOptions () {
            if (this.type !== 'select') return null
            let options = this.field.list_options && this.field.list_options.length > 0
                ? this.field.list_options : this.custom_select_options
            return options
        },
    }
}
</script>
<style scoped>
.input-container {
    display: flex;
    flex-direction: column;
    text-align: left;
    color: white;
    font-size: 15px;
}

input {
    border-radius: .8rem;
    padding: 0 10px;
    height: 50px;
    border: none;
    color: black;
}

.phone-input #MazPhoneNumberInput {
    display: flex;
    flex-direction: row;

    input {
        border-radius: 0;
    }
}

.checkbox-input {
    display: flex;
    flex-direction: row;
    align-items: center;

    label {
        margin: 0 10px;
        color: white;
    }

    input[type='checkbox']  {
        appearance: none;
        -moz-appearance: none;
        -webkit-appearance: none;
        -o-appearance: none;
        cursor: pointer;
        width: 20px !important;
        height: 20px !important;
        border-radius: 10%;
        background-color: white;
        outline: none;
    }

    input[type='checkbox']:checked {
        content: '';
        background-color: var(--prestaprenda-orange);
    }
}

.select-input {
    select {
        border-radius: .8rem;
        height: 50px;
        border: none;
        color: black;
        padding: 0 10px;
        padding-right: 25px;
        background-image: url('https://prestaprendacali-16905.kxcdn.com/public-assets/arrow-down-orange'); /* Custom arrow */
        background-repeat: no-repeat;
        background-position: right 10px center;
        background-size: 12px; /* Adjust size as needed */
    }

}
</style>

<style>
.input-tel.lg .input-tel__label {
    font-size: 10px !important;
}
</style>